import { Locale } from 'localisation';

const URL_BASE = process.env.REACT_APP_REST_API_URL;
const getXsollaItemsUrl = (
  groupExternalId?: string,
  country?: string | null,
  locale?: string,
  promocode?: string,
) => {
  if (groupExternalId) {
    return `${URL_BASE}/xsolla/get_items?external_id=${groupExternalId}&locale=${locale}&country=${country}`;
  }

  if (promocode) {
    return `${URL_BASE}/xsolla/get_items?locale=${locale}&country=${country}&promo_code=${promocode}`;
  }

  return `${URL_BASE}/xsolla/get_items?locale=${locale}&country=${country}`;
};

export const axiosGetXsollaItemsConfig = (
  groupExternalId?: string,
  country?: string | null,
  locale?: Locale,
  promocode?: string,
) => ({
  method: 'get',
  url: getXsollaItemsUrl(groupExternalId, country, locale, promocode),
});

export const PROMO_GROUP_ID = 'promo';
export const RECOMMENDS_GROUP_ID = 'recommends';
export const SPECIAL_GROUP_ID = 'special_offers';
export const TEST_GROUP_ID = 'test';
export const MAIN_GROUP_ID = 'main';

export type Currency = 'RUB' | 'USD' | 'EUR';
export const currencySymbolsMap: Record<Currency, string> = {
  RUB: '₽',
  USD: '$',
  EUR: '€',
};
